@if (path) {
  <div class="breadcrumbs">
    <a [routerLink]="['/']" [queryParams]="{domain: 0}" queryParamsHandling="merge">Home</a>
    @for (dom of path.path; track dom) {
      <span class="path">
        >> <a [routerLink]="['/']" [queryParams]="{domain: dom.id, term:''}" queryParamsHandling="merge">{{ dom.name }}</a>
      </span>
    }
  </div>
}
